<a class="nav-link dropdown-toggle white btn-hover-pepsico fnt-13" [class.pd-5-d]="isMobile()" href="#!" role="button"
  id="dropdownMenuLink22" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
  <img src="./assets/images/pepsico-icons-menu4.png" width="25">
  @if(wishListDataService.hasWishLists()){
  <span [class]="isMobile() ? 'items-carr-less' : 'icon-button__badge2'">
    {{ wishListDataService.wishListCounter() }}
  </span>
  }
</a>
@if(!isMobile()) {
<div class="hover-label">Lista de deseos</div>
}
<div class="dropdown-menu notificationBox" [class.notificationBox___mobile_wishlist]="isMobile()"
  aria-labelledby="dropdownMenuLink22">
  <div [class]="isMobile() ? 'notificationTriangle-wishlist-mobile' : 'notificationTriangle-wishlist-dekstop'"
    class="is-active"></div>
  @if(wishListDataService.hasWishLists()){
  <div class="notificationHeader">
    <div class="notificationHeader--title">
      Listas de deseos
    </div>
    <div class="notificationHeader--unread">
      <div>
        {{ wishListDataService.wishListCounter() }}
        {{ wishListDataService.wishListCounter() | i18nPlural: wishListMap()}}
      </div>
    </div>
  </div>
  <div>
    <div class="notificationList">
      <div>
        @for (wishList of wishListDataService.wishListData(); track wishList.idValue) {
        <div class="notification" [class.text-center]="isMobile()">
          <div class="container">
            <div class="row img-carrito">
              <div class="col-sm" (click)="viewWishList(wishList.textValue)">
                <p class="fnt-12">{{ wishList.textValue }}</p>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
    <div class="container">
      <div class="row jf-center">
        <button type="button" routerLink="wishlist" class="btn btn-red carrito-btn-2 w-290">
          Ver lista de deseos
        </button>
      </div>
    </div>
  </div>
  } @else {
  <div class="notificationHeader">
    <div class="notificationHeader--title">
      Actualmente no tienes lista de deseos.
    </div>
  </div>
  }
</div>